import React from "react";
import { Building2, Globe, Briefcase } from "lucide-react";
import type { SelectOption } from "@/components/ui/responsive-select";

export interface EnhancedCompanyOption extends SelectOption {
  industry?: string;
  website?: string;
  location?: string;
}

/**
 * Renderer for company options in `ResponsiveCommandSelect`.
 * Co-located with the company select shell, mirroring `ContactOptionPreview`.
 */
export const renderCompanyOption = (option: SelectOption): React.ReactNode => {
  const enhancedOption = option as EnhancedCompanyOption;

  return (
    <div className="flex flex-col gap-1.5 w-full">
      {/* Header: Company Name */}
      <div className="flex items-center gap-2">
        <Building2 className="h-4 w-4 flex-shrink-0 text-muted-foreground" />
        <span className="font-medium">{enhancedOption.label}</span>
      </div>

      {/* Details: Industry, Website, Location in horizontal layout */}
      <div className="flex flex-wrap gap-3 text-xs text-muted-foreground">
        {enhancedOption.industry && (
          <div className="flex items-center gap-1">
            <Briefcase className="h-3 w-3 flex-shrink-0" />
            <span className="capitalize">{enhancedOption.industry}</span>
          </div>
        )}
        {enhancedOption.website && (
          <div className="flex items-center gap-1 min-w-0">
            <Globe className="h-3 w-3 flex-shrink-0" />
            <span className="truncate text-blue-600">{enhancedOption.website}</span>
          </div>
        )}
        {enhancedOption.location && (
          <div className="flex items-center gap-1 min-w-0">
            <span className="truncate">{enhancedOption.location}</span>
          </div>
        )}
      </div>
    </div>
  );
};
